import { Component } from '@angular/core';

@Component({
    selector: 'app-patient-retrieve-files',
    templateUrl: './patient-retrieve-files.component.html',
    styleUrls: ['./patient-retrieve-files.component.scss'],
    standalone: false
})
export class PatientRetrieveFilesComponent {
  constructor() {}
}
